export const QUERY_KEY = {
    GET_INTRO_INFO: "GET_INTRO_INFO",
    GET_BASE_INFO: "GET_BASE_INFO",
    GET_DMAX_INFO: "GET_DMAX_INFO",
    GET_COMMON_INFO: "GET_COMMON_INFO",
    GET_DMAX_COMMON_INFO: "GET_DMAX_COMMON_INFO",
    GET_LOCATION_INFO: "GET_LOCATION_INFO",
    GET_ROOM_INFO: "GET_ROOM_INFO",
    GET_SPECIAL_INFO: "GET_SPECIAL_INFO",
    GET_GUIDE_INFO: "GET_GUIDE_INFO",
    GET_RESERVE_INFO: "GET_RESERVE_INFO",
    GET_POP_UP_INFO: "GET_POP_UP_INFO",
};
